import React from 'react';

const ShowApproval = ({clickHandler , style}) => (
    <a href="javascript:;"
    onClick={clickHandler}
    style={style}
    >
    <i className="fa fa-file-text-o" aria-hidden="true"></i>查看审核意见
    </a>
);

export default ShowApproval;